/**
 * @description Simple hook that retrieves existing subject in SECCON based on SSN
 */
import React from 'react';
import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';
import isEmpty from 'lodash/isEmpty'

const useExistingPersonnel = () => {
  const [existingPersonnel, setExistingPersonnel] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false)
  const { warning } = React.useContext(ToastContext);
  /**
   * Handles API successes by storing the list of personnel
   * @param response [] - list of personnel
   */
  function handleSuccess (response) {
    setIsLoading(false)
    setExistingPersonnel(
      response
    );
  }

  /**
   * Handles API request failures by notifying the user
   * @param err {{ message: string }} - API error response
   */
  function handleFailure ({ body: err }) {
    const msg = err?.message ? `Warning: ${ err.message }` : 'Unable to load personnel update preview; sync file could not processed';

    warning(msg);
    setIsLoading(false)
  }

  function checkForExistingPersonnel (syncFile, syncMap, syncOnSsn) {
    if (!isEmpty(syncFile)) {
      setIsLoading(true)
      // Prepare the form data
      const requestBody = new FormData();
      requestBody.append('mappingName', syncMap);
      requestBody.append('personnelFile', syncFile[0]);
      requestBody.append('syncOnSsn', syncOnSsn);
      fetch('/personnelSync/existingPersonnel', {
        method: 'POST',
        body: requestBody
      })
        .then(decodeJson)
        .then(handleSuccess)
        .catch(handleFailure)
    }
  }

  return {
    existingPersonnel, checkForExistingPersonnel, isLoading, setExistingPersonnel
  };
};

export default useExistingPersonnel;
